/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const DeleteMyUserAccountResponse = zod.object({
  success: zod.literal(true),
});

export type DeleteMyUserAccountResponse = zod.input<typeof DeleteMyUserAccountResponse>;
export type DeleteMyUserAccountResponseOutput = zod.output<typeof DeleteMyUserAccountResponse>;
